/* eslint-disable */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, Toaster } from "sonner";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { adminApi, setAdminSession } from "@/lib/adminApi";
import { RegulensMark } from "@/components/RegulensMark";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await adminApi.post("/admin/auth/login", { email, password });
      setAdminSession(data.admin_token, data.expires_at);
      navigate("/admin/dashboard");
    } catch (err) {
      // Item 2 — server-side lockout returns 423 with a human-readable message.
      const status = err?.response?.status;
      const detail = err?.response?.data?.detail || "Invalid credentials";
      if (status === 423 || status === 429) {
        toast.error(detail, { duration: 8000 });
      } else {
        toast.error(detail);
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--rg-bg)] grain px-6">
      <Toaster theme="dark" position="top-right" offset={80} />
      <form
        onSubmit={submit}
        className="w-full max-w-md rounded-lg border border-[var(--rg-border)] bg-[var(--rg-surface)] p-8"
        data-testid="admin-login-form"
      >
        <div className="flex items-center gap-3 mb-3">
          <RegulensMark size={26} theme="dark" />
          <span className="font-heading font-extrabold text-xl text-[var(--rg-text-strong)]">Restricted Access</span>
        </div>
        <h1 className="font-heading font-bold text-2xl text-[var(--rg-text-strong)] mb-1">Sign in</h1>
        <p className="text-sm text-[var(--rg-text)] mb-6">Use your authorized credentials.</p>

        <Label className="text-[var(--rg-text)] text-xs uppercase tracking-[0.18em]">Email</Label>
        <Input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoComplete="email"
          className="bg-[var(--rg-surface)] border-[var(--rg-border)] text-[var(--rg-text-strong)] mt-1 mb-4"
          data-testid="admin-login-email"
        />

        <Label className="text-[var(--rg-text)] text-xs uppercase tracking-[0.18em]">Password</Label>
        <Input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          autoComplete="current-password"
          className="bg-[var(--rg-surface)] border-[var(--rg-border)] text-[var(--rg-text-strong)] mt-1 mb-6"
          data-testid="admin-login-password"
        />

        <Button
          type="submit"
          disabled={busy}
          className="w-full bg-[var(--rg-sage)] text-[var(--rg-on-sage)] hover:bg-[var(--rg-sage-hover)] font-semibold"
          data-testid="admin-login-submit"
        >
          {busy ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Verifying…</> : "Sign in"}
        </Button>
      </form>
    </div>
  );
}
